import React from 'react';

import EVENT_STATUS from 'constants/salon/eventStatus.const';
import asObject from 'utils/objects/asObject.util';

import EventModalPatchTest from 'scheduler/components/EventModalPatchTest';
import EventModalTimeOff from 'scheduler/components/EventModalTimeOff';

const EventModal = ({ tag, event, onClose, onDeleteEvent, dayView, onLoad, onUnload }) =>
  asObject(event).status === EVENT_STATUS.patchTest ? (
    <EventModalPatchTest
      tag={tag}
      event={event}
      onClose={onClose}
      onDeleteEvent={onDeleteEvent}
      onLoad={onLoad}
      onUnload={onUnload}
    />
  ) : (
    <EventModalTimeOff tag={tag} dayView={dayView} event={event} onClose={onClose} onDeleteEvent={onDeleteEvent} />
  );

export default EventModal;
